/* eslint-disable react/require-default-props */

import React from 'react'
import DOMPurify from 'dompurify'
import {
  SpecialVideoPropTypes
} from 'components/SpecialVideos/SpecialVideoDetail'

function SpecialVideoOverview({ body = '' }) {
  return (
    <div className="SpecialVideoOverview">
      <div className="description formatted" dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(body) }} />
    </div>
  )
}

SpecialVideoOverview.propTypes = SpecialVideoPropTypes

export default SpecialVideoOverview
